export default __webpack_public_path__ + "static/media/optionsIcon.fd35aa2b.svg";